<template>
    <MaltImg v-bind="imgProps" :src="illustrationSrc" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import MaltImg, {type MaltImgProps} from './MaltImg.vue';
    import type {MaltIllustrationName, MaltIllustrationQueryParams} from '../types/malt-illustration-name';

    interface Props extends Omit<MaltImgProps, 'src'> {
        name: MaltIllustrationName;
        extension?: string;
        queryParams?: MaltIllustrationQueryParams;
    }

    const props = withDefaults(defineProps<Props>(), {
        extension: 'svg',
    });

    const illustrationSrc = computed(() => {
        const extension = props.extension.replace(/^\./, '');
        const fileName = `${props.name}.${extension}`;
        const search = new URLSearchParams();

        for (const [key, value] of Object.entries(props.queryParams ?? {})) {
            if (value) {
                search.set(key, value);
            }
        }

        const query = search.toString();
        const path = `https://dam.malt.com/brand/illustrations/2026/${fileName}`;

        return query ? `${path}?${query}` : path;
    });

    const imgProps = computed(() => {
        const {name: _name, extension: _extension, queryParams: _queryParams, ...rest} = props;
        return rest;
    });
</script>
